import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<HelpComponent>
  ) { }

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  } 

  onNoClick(): void {
    this.dialogRef.close();
  }  

}
